import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  error: null,
  userData: null,
};

const UserReducer = createSlice({
  name: "User",
  initialState,
  reducers: {
    getUserRequest: (state) => {
      state.isLoading = true;
      state.error = null;
      state.userData = null;
      console.log(state.userData)
    },
    getUserSuccess: (state, action) => {
      state.isLoading = false;
      state.userData = action.payload;
    },
    getUserFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    clearUserState: (state) => {
      state.isLoading = false;
      state.error = null;
      state.userData = null;
    },
  },
});

export const {
  getUserRequest,
  getUserSuccess,
  getUserFailure,
  clearUserState,
} = UserReducer.actions;

export default UserReducer.reducer;
